import { render, staticRenderFns } from "./EditConnection.vue?vue&type=template&id=54683b21&scoped=true&"
import script from "./EditConnection.vue?vue&type=script&lang=js&"
export * from "./EditConnection.vue?vue&type=script&lang=js&"
import style0 from "./EditConnection.vue?vue&type=style&index=0&id=54683b21&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54683b21",
  null
  
)

export default component.exports